import React from "react";
import SelectOrderStrategy from "./SelectOrderStrategy";
import {OrderShipmentDateMethodStrategies} from "../../../../app/order/GetStrategies";

const SelectOrderShipmentDateMethodStrategy = React.forwardRef(({onChange, ...props}, ref) => (
    <SelectOrderStrategy onChange={onChange} strategies={OrderShipmentDateMethodStrategies} {...props} ref={ref}/>
));

export default SelectOrderShipmentDateMethodStrategy;